import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: '¿Funciona si ya tengo menopausia avanzada?',
  a: 'Sí. El método está diseñado para cualquier fase: perimenopausia, menopausia o postmenopausia. Las estrategias se adaptan a tu cuerpo donde sea que estés.'
}, {
  q: '¿Tengo que dejar mis medicamentos?',
  a: 'No. Esta guía complementa cualquier tratamiento médico. Nunca cambies tus medicamentos sin hablar con tu doctor.'
}, {
  q: '¿Cómo recibo el ebook?',
  a: 'Después de pagar, recibes un correo con el link de descarga en menos de 2 minutos. Lo puedes leer en tu teléfono, tablet o computadora.'
}, {
  q: '¿Y si no me funciona?',
  a: 'Tienes 7 días para pedir tu reembolso completo. Sin preguntas, sin formularios. Escribes un email y listo.'
}, {
  q: '¿Está en español de verdad?',
  a: 'Sí, 100% escrito originalmente en español por una persona latina. No es traducción de Google.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-white px-5 py-10 md:py-16" aria-labelledby="faq-heading" data-id="element-44">
      <div className="mx-auto max-w-container" data-id="element-45">
        <h2 id="faq-heading" className="font-serif text-[22px] font-medium text-wine md:text-[24px]" data-id="element-46">
          Preguntas frecuentes
        </h2>

        <div className="mt-6 flex flex-col gap-3" data-id="element-47">
          {faqs.map((item, i) => {
          const isOpen = open === i;
          return <div key={i} className="overflow-hidden rounded-[12px] border border-pinkLight bg-white" data-id="element-48">
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left transition-colors hover:bg-cream/50 focus:outline-none focus-visible:bg-cream" aria-expanded={isOpen} aria-controls={`faq-${i}`} data-id="element-49">
                  <span className="text-[15px] font-medium text-wine" data-id="element-50">
                    {item.q}
                  </span>
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-cream text-rose" aria-hidden="true" data-id="element-51">
                    {isOpen ? <MinusIcon size={14} data-id="element-52" /> : <PlusIcon size={14} data-id="element-53" />}
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-54">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeOut'
              }} data-id="element-55">
                      <div className="px-4 pb-4 text-[14px] leading-relaxed text-burgundy" data-id="element-56">
                        {item.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}